import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SessionService } from '../../services/session.service';
import { PageComponent } from '../../components/page/page.component';
import { AuthenticationStatus } from '../../util/util';
import { TranslateModule } from '@ngx-translate/core';
import { LocationsComponent } from '../../components/locations/locations.component';
import { LocationsModel } from '../../components/locations/locations-model';
import { BackendService } from '../../services/backend.service';
import { TitleComponent } from 'src/app/general/components/title/title.component';
import { StripeAccountLocationsModel } from '../../components/locations/stripe-account-locations-model';
import { RouteUtil } from 'src/app/general/util/route-util';
import { Util } from 'src/app/general/util/util';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-stripe-account-locations-page',
  standalone: true,
  imports: [
    CommonModule,
    PageComponent,
    TranslateModule,
    TitleComponent,
    LocationsComponent
  ],
  templateUrl: './stripe-account-locations-page.component.html',
  styleUrls: ['./stripe-account-locations-page.component.css']
})
export class StripeAccountLocationsPageComponent implements OnInit {

  stripeAccountId: string;
  locationsModel: LocationsModel;

  constructor(
      private sessionService: SessionService,
      private backendService: BackendService,
      private activatedRoute: ActivatedRoute) {
    this.stripeAccountId = '';
    this.locationsModel = new StripeAccountLocationsModel(this.stripeAccountId, this.backendService);
  }

  ngOnInit(): void {
    if (this.sessionService.enforceAuthentication()
        == AuthenticationStatus.USER_NOT_AUTHENTICATED_AND_REDIRECTED_TO_SIGNIN_PAGE) {
      return;
    }

    const pathParams = RouteUtil.getPathParams(this.activatedRoute);
    this.stripeAccountId = Util.safeString(pathParams.get('stripeAccountId'));
    this.locationsModel = new StripeAccountLocationsModel(this.stripeAccountId, this.backendService);
  }
}
